import Alpine from "alpinejs";
import Swiper, {
  Navigation,
  Pagination,
  Keyboard,
  Controller,
  EffectFade,
  Autoplay,
} from "swiper";
import { formatMoney } from "@shopify/theme-currency";
import "fslightbox";

import {
  CartRemoveButton,
  CartItems,
  QuantityInput,
  VariantSelects,
  ProductForm,
  CartNote,
  QuantityPopover,
  ShowMoreButton
} from "./components";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/keyboard";
import "swiper/css/controller";
import "swiper/css/autoplay";

const { COUNT, TOTAL, UPDATE_URL, ADD_URL } = window.CART;

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

const locale = "es-CL";
const currency = "CLP";
const formattedNumber = new Intl.NumberFormat(locale, {
  currency: currency,
  style: "currency",
  minimumFractionDigits: 0,
});

window.formattedNumber = formattedNumber;
window.Alpine = Alpine;
window.Swiper = Swiper;
window.Pagination = Pagination;
window.Navigation = Navigation;
window.Keyboard = Keyboard;
window.Controller = Controller;
window.EffectFade = EffectFade;
window.Autoplay = Autoplay;
window.formatMoney = formatMoney;

Alpine.start();

customElements.define("cart-remove-button", CartRemoveButton);
customElements.define("cart-items", CartItems);
customElements.define("quantity-input", QuantityInput);
customElements.define("variant-selects", VariantSelects);

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}

//cart note
if (!customElements.get("cart-note")) {
  customElements.define("cart-note", CartNote);
}
//quantity popover
if (!customElements.get("quantity-popover")) {
  customElements.define("quantity-popover", QuantityPopover);
}

//Show More button
if (!customElements.get("show-more-button")) {
  customElements.define("show-more-button", ShowMoreButton);
}
